import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const useCanResyncQbo = (param)=>{
    let { enabled, invoiceId } = param;
    const { api } = useStoreActions();
    const { data, isFetching, refresh } = useQueryState({
        queryKey: [
            QueryKeys.CanResyncQbo,
            invoiceId
        ],
        queryFn: ()=>api.invoice.getResyncQboStatus(invoiceId),
        refreshOnHookMount: (query)=>{
            var _query_state_data;
            return !!((_query_state_data = query.state.data) === null || _query_state_data === void 0 ? void 0 : _query_state_data.canResync);
        },
        enabled
    });
    return {
        canResyncQbo: !isFetching && !!(data === null || data === void 0 ? void 0 : data.canResync),
        refreshQbo: refresh
    };
};
